import React, { Dispatch, SetStateAction, useState } from 'react';
import Layout from './components/layout';
import { PAYMENT_CONFIG } from 'state/paymentConfig/type';
import DeviceConfig from './components/deviceConfig';
import { PaymentSolutionTab } from 'state/paymentConfig/type';
import { initialDeviceConfig } from './atm';

interface IProps {
  defaultProvider: PAYMENT_CONFIG.IProcessors | undefined;
  setDefaultProvider: Dispatch<
    SetStateAction<PAYMENT_CONFIG.IProcessors | undefined>
  >;
  activeTab: PaymentSolutionTab;
}
const IntegratedAch = ({
  defaultProvider,
  setDefaultProvider,
  activeTab,
}: IProps): JSX.Element => {
  const [deviceConfig, setDeviceConfig] = useState<Record<string, string | null | undefined>>(initialDeviceConfig);

  return (
    <>
      <Layout
        defaultProvider={defaultProvider}
        setDefaultProvider={setDefaultProvider}
        activeTab={activeTab}
        localTab={PaymentSolutionTab.ACH}
      />
      <DeviceConfig
        defaultProvider={defaultProvider}
        activeTab={activeTab}
        localTab={PaymentSolutionTab.ACH}
        deviceConfig={deviceConfig}
        setDeviceConfig={setDeviceConfig}
        showTestButton={false}
      />
    </>
  );
};

export default IntegratedAch;
